import { infiniteQueryOptions, keepPreviousData } from '@tanstack/react-query';

import type { GetPeopleReviewsQuery } from '@schema/cart';
import {
  ProductsCommentsTypeEnum,
  StoreOrProductCommentsTypeEnum
} from '@schema/cart';

import API from '@api';

type PeopleReviewsPageT = GetPeopleReviewsQuery['getPeopleReviews'];

export type PeopleProductReviewItemT = NonNullable<
  NonNullable<PeopleReviewsPageT>['commentsItems']
>[number];

export type PeopleShopReviewItemT = NonNullable<
  NonNullable<PeopleReviewsPageT>['reviewsItems']
>[number];

export const PEOPLE_REVIEWS_QUERY_KEY = 'peopleReviews';
export const PEOPLE_SHOP_REVIEWS_QUERY_KEY = [
  PEOPLE_REVIEWS_QUERY_KEY,
  'shop'
] as const;
export const PEOPLE_PRODUCTS_REVIEWS_QUERY_KEY = [
  PEOPLE_REVIEWS_QUERY_KEY,
  'products'
] as const;

export const PEOPLE_REVIEWS_LIMIT = 6;

const getNextPageParam = (
  lastPage: PeopleReviewsPageT,
  _allPages: PeopleReviewsPageT[],
  lastPageParam: number
): number | undefined => {
  const total = lastPage?.totalCount || 0;
  return lastPageParam * PEOPLE_REVIEWS_LIMIT < total
    ? lastPageParam + 1
    : undefined;
};

export const peopleShopReviewsInfiniteQueryOptions = () =>
  infiniteQueryOptions({
    queryKey: PEOPLE_SHOP_REVIEWS_QUERY_KEY,
    queryFn: ({ pageParam }) =>
      API.getPeopleReviews({
        page: pageParam,
        type: StoreOrProductCommentsTypeEnum.StoreReview,
        setLimit: PEOPLE_REVIEWS_LIMIT
      }).then(res => res.getPeopleReviews),
    initialPageParam: 1,
    getNextPageParam,
    gcTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });

export const peopleProductsReviewsInfiniteQueryOptions = (
  productCommentType = ProductsCommentsTypeEnum.All
) =>
  infiniteQueryOptions({
    queryKey: [...PEOPLE_PRODUCTS_REVIEWS_QUERY_KEY, productCommentType],
    queryFn: ({ pageParam }) =>
      API.getPeopleReviews({
        page: pageParam,
        type: StoreOrProductCommentsTypeEnum.ProductReview,
        productCommentType,
        setLimit: PEOPLE_REVIEWS_LIMIT
      }).then(res => res.getPeopleReviews),
    initialPageParam: 1,
    getNextPageParam,
    placeholderData: keepPreviousData,
    gcTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
